/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempArrowsDownDoubleTop2: {
  name: 'temp-arrows-down-double-top-2';
  data: string;
} = {
  name: 'temp-arrows-down-double-top-2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1H3Zm0 3a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1H3Z" fill="currentColor"/></svg>`,
};
